<ion-header *ngIf="(platform.ANDROID || platform.IOS) && !platform.isBrowser">
    <ion-toolbar>
      <ion-title>
        Login
      </ion-title>
    </ion-toolbar>
</ion-header>

<!-- <ion-content> -->
    <div class="flex flex-wrap align-items-center justify-content-center h-screen relative p-5 md:p-8 text-sm">
        <p-avatar image="/assets/img/login-bg.jpg" styleClass="w-full h-full absolute left-0 top-0 hidden md:block"></p-avatar>
        <p-avatar image="/assets/img/login-mobile-bg.jpg" styleClass="w-full h-full absolute left-0 top-0 md:hidden"></p-avatar>
    <!-- Form -->
    <div class="surface-0 text-900 relative z-1 lg:flex-order-1 p-3 md:p-5 shadow-2 md:w-30rem border-round-2xl">
        <div class="flex justify-content-between align-items-center mb-4">
            <div class="flex-grow-1">
                <img *ngIf="(companyInfoDetail$ | async)?.compDetails?.logo" 
                    width="180" 
                    class="mx-auto"
                    [src]="(companyInfoDetail$ | async)?.compDetails?.logo" 
                    [alt]="(companyInfoDetail$ | async)?.compDetails?.app_type || 'Logo'">
            </div>
            <app-lang-dropdown 
                [Lang]="companyInfoDetail$ | async" 
                (EmitLang)="selectedLang($event)">
            </app-lang-dropdown>
        </div>
        <div>
            <!-- Header -->
            <div class="form__header text-center">
                <h6 class="text-sm mt-4 mb-1">{{'Auth.login.TITLE' | translate}}</h6>
                <p>{{'Auth.login.WELCOME_BACK' | translate}}</p>
            </div>

            <!-- Form Social -->
            <div class="flex justify-content-center">
                <button pButton pRipple class="p-ripple p-element text-xs md:text-sm text-700 p-button-outlined border-400 p-button-secondary p-button p-component py-1 px-3" type="button" aria-label="google-login-button" (click)="openSocialLoginPopup('google')">
                    <span class="p-button-icon p-button-icon-left"><img src="/assets/img/logo-google.svg" alt="Google Logo"></span>
                    <span class="p-button-label">{{'Auth.login.GOOGLE_LOGIN' | translate}}</span>
                </button>
                <button pButton pRipple class="p-ripple p-element text-xs md:text-sm text-700 p-button-outlined border-400 p-button-secondary p-button p-component py-1 px-3 mx-2" type="button" aria-label="microsoft-login-button" (click)="openSocialLoginPopup('microsoft')">
                    <span class="p-button-icon p-button-icon-left"><img src="/assets/img/logo-microsoft.svg" alt="Microsoft Logo"></span>
                    <span class="p-button-label">{{'Auth.login.MICROSOFT_LOGIN' | translate}}</span>
                </button>
                <button pButton pRipple class="p-ripple p-element text-xs md:text-sm text-700 p-button-outlined border-400 p-button-secondary p-button p-component py-1 px-3" type="button" aria-label="apple-login-button" (click)="openSocialLoginPopup('apple')">
                    <span class="p-button-icon p-button-icon-left fab fa-apple text-xl md:text-2xl text-900"></span>
                    <span class="p-button-label">{{'Auth.login.APPLE_LOGIN' | translate}}</span>
                </button>
            </div>

            <p-divider align="center" styleClass="my-4 text-500 text-xs">or</p-divider>

            <!-- Form Fields -->
            <form [formGroup]="loginForm" (ngSubmit)="validateUserLogin(loginForm)" class="form__fields text-left">
                <div class="mb-3">
                    <label class="block font-medium text-900 mb-1">{{'Auth.login.USERNAME' | translate}}</label>
                    <input type="text" pInputText formControlName="username" class="w-full" aria-label="username-input" [placeholder]="'Auth.login.USERNAME-PLACEHOLDER' | translate">
                    <app-error-msg *ngIf="Username.touched && Username.invalid" [errors]="Username.errors" [fieldLabel]="'Auth.login.USERNAME' | translate"></app-error-msg>
                </div>

                <div class="mb-3">
                    <div class="flex align-items-center justify-content-between mb-0">
                        <label class="block font-medium text-900 mb-1">{{'Auth.login.PASSWORD' | translate}}</label>
                        <a [routerLink]="'/auth/forgot-password'" class="text-primary">{{ 'Auth.forgot-password.TITLE' | translate }}</a>
                    </div>
                    <p-password [toggleMask]="true" [feedback]="false" styleClass="w-full" aria-label="password-input" [placeholder]="'Auth.login.PASSWORD-PLACEHOLDER' | translate" formControlName="password"></p-password>
                    <app-error-msg *ngIf="Password.touched && Password.invalid" [errors]="Password.errors" [fieldLabel]="'Auth.login.PASSWORD' | translate"></app-error-msg>
                </div>

                <div class="mb-5">
                    <button type="submit" pButton [loading]="isFormSubmitting" [disabled]="!loginForm.valid || !validCompanyFound" [label]="'Auth.login.LOGIN-BUTTON-TEXT' | translate" aria-label="login-submit-button" class="w-full"></button>
                </div>
            </form>

            <!-- Need Help -->
            <div class="text-center">
                <h6 class="text-600 text-sm font-normal mb-2">{{'Auth.login.NEED_HELP' | translate}}</h6>
                <button pButton pRipple icon="fa fa-cog" [label]="'common.BUTTONS.BTN_CONTACT_SUPPORT' | translate" aria-label="contact-support-button" (click)="showSupportPopup = true" class="p-button-outlined p-button-secondary border-round-3xl text-sm text-700"></button>
            </div>
        </div>
    </div>
    <div class="text-center lg:text-left text-white flex flex-column justify-content-center lg:mr-8 relative z-1 mt-4 lg:mt-0">
        <h1 class="md:text-4xl xl:text-6xl mb-3 pb-2">Built for Growth, <br class="hidden xl:block"> Designed for Ease.</h1>
        <h2 class="mb-0 md:text-xl xl:text-2xl font-light">A Fresh Look. A Better Experience.
            <br> The Same Powerful Platform. <br> We've made big improvements,
            <br> so you can work smarter, not harder.</h2>
    </div>
</div>


<app-help-support [visibility]="showSupportPopup" (closeDialog)="closeSupportDialog($event)"></app-help-support>
<!-- </ion-content> -->